import styled from 'styled-components';
import { mq } from '../../../stylesheets/tools';
import { fontFamilies } from '../../../stylesheets/settings';

const StyledCompactLoginMask = styled.div`
  position: relative;
  display: block;
  .loginMask__form {
    position: relative;

    .loginMask__form-topline {
      color: white;
      font-size: 14px;
      text-align: center;
      margin-bottom: 10px;
    }
  }
  .tokenInput__instructions {
    color: white;
  }
  .loginMask__form-container {
    overflow: hidden;
    position: relative;
    z-index: 1;
  }
  .loginMask__form-group {
    position: relative;
    widht: 100%;
    flex: 1;

    .loginMask__form-icon {
      position: absolute;
      left: 10px;
      top: 0;
      z-index: 2;
      height: 100%;
      display: flex;
      align-items: center;
      color: white;

      svg {
        width: 20px;
      }
    }
    .loginMask__input {
      .tokenInput__container {
        input {
          background: #111111;
          padding: 20px 40px 20px 40px;
          font-family: ${fontFamilies.default};
          font-style: normal;
          font-size: 14px;

          ${mq('s')} {
            font-size: 18px;
          }

          &::placeholder {
            font-style: normal;
          }
        }
        &:after {
          content: unset;
        }
      }
    }
  }
  .loginMask__form-container {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .loginMask__submit {
    height: 60px;
    width: 60px;
    background: white;
    border-radius: 50%;
    margin-left: -30px;
    position: relative;
    z-index: 8;
    border: 1px solid black;

    ${mq('s')} {
      margin-left: -35px;
      height: 70px;
      width: 70px;
    }

    .loginMask__icon {
      height: 100%;
      width: 100%;
    }
  }
`;

export default StyledCompactLoginMask;
